import type { Massnahme, MassnahmeCreate, MassnahmeUpdate, MassnahmenStatus, Risiko, Ereignis } from "@iso27001/shared";
import { apiFetch } from "./client.js";
import type { AuditEntry } from "../components/AuditHistoryModal.js";

interface ListResp<T> { items: T[]; total: number; page: number; pageSize: number; }

export const massnahmenLinks = {
  listRisiken: (id: number) => apiFetch<{ items: Risiko[] }>(`/api/massnahmen/${id}/risiken`),
  listEreignisse: (id: number) => apiFetch<{ items: Ereignis[] }>(`/api/massnahmen/${id}/ereignisse`),
  linkEreignis: (massnahmeId: number, ereignisId: number) =>
    apiFetch<{ massnahmeId: number; ereignisId: number }>(`/api/massnahmen/${massnahmeId}/ereignisse/${ereignisId}`, { method: "PUT" }),
  unlinkEreignis: (massnahmeId: number, ereignisId: number) =>
    apiFetch<null>(`/api/massnahmen/${massnahmeId}/ereignisse/${ereignisId}`, { method: "DELETE" }),
};

export const massnahmenApi = {
  list: (params: { q?: string; status?: MassnahmenStatus; page?: number; pageSize?: number } = {}): Promise<ListResp<Massnahme>> => {
    const qs = new URLSearchParams();
    if (params.q) qs.set("q", params.q);
    if (params.status) qs.set("status", params.status);
    if (params.page) qs.set("page", String(params.page));
    if (params.pageSize) qs.set("pageSize", String(params.pageSize));
    const url = `/api/massnahmen${qs.toString() ? `?${qs}` : ""}`;
    return apiFetch<ListResp<Massnahme>>(url);
  },
  get: (id: number): Promise<Massnahme> => apiFetch<Massnahme>(`/api/massnahmen/${id}`),
  create: (body: MassnahmeCreate): Promise<Massnahme> =>
    apiFetch<Massnahme>("/api/massnahmen", { method: "POST", body: JSON.stringify(body) }),
  update: (id: number, body: MassnahmeUpdate): Promise<Massnahme> =>
    apiFetch<Massnahme>(`/api/massnahmen/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (id: number): Promise<null> =>
    apiFetch<null>(`/api/massnahmen/${id}`, { method: "DELETE" }),
  audit: (id: number): Promise<{ items: AuditEntry[] }> =>
    apiFetch<{ items: AuditEntry[] }>(`/api/massnahmen/${id}/audit`),
};
